<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
  </div>
</template>

<script>
export default {
  name: "validacionHerramientasModal",
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      tituloModalHerramientas: null,
      parrafoHerramienta: null,
      bagesHerramienta: null,
      tituloBotonAceptar: null,
      imagenModalBase64: null,
      listaHerramientasFaltantes: "",
      tituloBotonCancelar: null,
      colorButtonConfirmar: null,
      borrador: false,
      numeroHerramientas: null
    }
  },
  props: {
    idPaciente:Number,
    ptiSinHerramientas: Boolean,
    activoEnDiagnocat: Boolean,
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    async vadicionActivarEceClinica() {
      const params = {
        idFlujo: 1,
        idPaciente: this.idPaciente,
        idClinica: this.$localStorageService.getIdClinica(),
      }
      return await this.$http.post(
          this.$api + "herramientaExpedienteElectronico/obtenerHerramientasFaltantes", params
      );
    },
    async modalValidacionHerramientas() {

      if(this.ptiSinHerramientas === true){
        this.$emit('continuar', true);
        this.$emit('numeroHerramientas', 0);
        this.$emit('guardarNormal');
        return;
      }

      const rep = await this.vadicionActivarEceClinica();
       this.numeroHerramientas = rep.data.data.length;
      this.listaHerramientasFaltantes = "";
      if(rep.data.data.length === 0 || this.activoEnDiagnocat){
        this.imagenModalBase64 = "data:image/png;base64,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";
        this.bagesHerramienta = '<div><span class="badge badge-success">Herramientas Completas</span></div>';
        this.tituloModalHerramientas = '<span class="mt-4" style="font-weight:600; font-size: 20px">¿Estás seguro de que quieres continuar?</span></br>';
        this.parrafoHerramienta = '<span class="mt-5" style="font-weight:600; color: #e98918; font-size: 17px">Una vez que se envié la hoja de diagnóstico, no se podrán hacer</br>' +
            ' cambios</span>';
        this.tituloBotonAceptar = 'Si, continuar';
        this.tituloBotonCancelar = this.activoEnDiagnocat ? 'Guardar Como Borrador' :'No, cancelar'
        this.colorButtonConfirmar = '#e98918';
        this.borrador = false;
      }else if (rep.data.data.length > 0 && rep.data.message !== "Expediente Clinico Electronico esta desactivado"){
        this.imagenModalBase64 = "data:image/png;base64,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"
        this.bagesHerramienta = '<div><span class="badge badge-danger">'+rep.data.message+'</span></div>';
        this.tituloModalHerramientas = '<span class="mt-4" style="font-weight:600; font-size: 20px">Para continuar debes de cargar las herramientas: </span></br></br></br></br>';
        this.parrafoHerramienta = '<span class="mt-5" style="font-weight:600; color: #C31C1C; font-size: 17px">¿Deseas guardar tu hoja de diagnóstico como borrador?</br>' +
            'Podrás acceder cuando quieras</span>';
        this.tituloBotonAceptar = 'Guardar como borrador';
        this.tituloBotonCancelar = 'Cancelar'
        this.colorButtonConfirmar = '#C31C1C';
        this.borrador = true;
        rep.data.data.forEach((h)=>{
          this.listaHerramientasFaltantes += "<li style='list-style: disc !important;'><strong>"+h.cantidadArchivoFalta+" "+h.herramientasECEDTO.nombreHerramienta+"</strong></li>"
        })
        this.listaHerramientasFaltantes = "<ul>"+this.listaHerramientasFaltantes+"</ul>"
      }
      this.$emit('borrador', this.borrador);
      this.$swal.fire({
        width: '700px',
        html:'<div class="container-fluid cew-9"> ' +
            this.bagesHerramienta+
            '<img alt="herramientas" class="mt-3" src="'+this.imagenModalBase64+'"></br>'+
            ' <div class="row justify-content-center">' +
            this.tituloModalHerramientas+
            this.listaHerramientasFaltantes+
            this.parrafoHerramienta+
            ' </div>' +
            '</div>',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.tituloBotonAceptar,
        confirmButtonColor: this.colorButtonConfirmar,
        cancelButtonColor: "#595959",
        cancelButtonText: this.tituloBotonCancelar,
        customClass: {
          confirmButton: 'rounded-pill',
          cancelButton: 'rounded-pill'
        }
      }).then((result) => {

        if (this.activoEnDiagnocat && result.isDismissed){

          this.borrador = true;
          this.continuar = true;
          this.$emit('continuar', true);
          this.$emit('numeroHerramientas', 0);

          this.$emit('guardarBorrador');

        }else if (result.isConfirmed && !this.borrador) {
          this.$emit('continuar', true);
          this.$emit('numeroHerramientas', this.numeroHerramientas);
          this.$emit('guardarNormal');
        }else if (result.isConfirmed && this.borrador) {
          this.$emit('continuar', true);
          this.$emit('numeroHerramientas', this.numeroHerramientas);
          this.$emit('guardarBorrador');
        }else if(result.isDismissed) {
          this.$emit('continuar', false);
          this.$emit('numeroHerramientas', 0);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
